import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const PictureInPictureAltIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"picture_in_picture_alt"} ref={ref}/>
});

PictureInPictureAltIcon.displayName = "PictureInPictureAltIcon";
